import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';

function OnLoadingContentView(props) {
  let message = (<h2>{I18n.tr('global.loading')}...</h2>);

  if (props.displayMessage === false) {
    message = (null);
  }

  return (
    <div className="on_loading_content_view text-center">
      {message}
    </div>
  );
}

OnLoadingContentView.propTypes = {
  /**
   * Should we display a loading message ?
   */
  displayMessage: PropTypes.bool
};

OnLoadingContentView.defaultProps = {
  displayMessage: true
};

export default OnLoadingContentView;
